import { InjectionToken } from '@angular/core';
import { EditorDimenstions, EditorRatio, TextTypes } from '../models/overlay-editor.model';

export const TEXT_ALIGN = [
  { icon: 'textLeft', value: 'left' },
  { icon: 'textCenter', value: 'center' },
  { icon: 'textRight', value: 'right' }
];

export enum TextAlignEnum {
  left = 'left',
  center = 'center',
  right = 'right'
}

export const CROSS_OUT_DIRECTION = [
  { icon: 'crossOutDirectionUp', value: 'up' },
  { icon: 'crossOutDirectionCenter', value: 'center' },
  { icon: 'crossOutDirectionDown', value: 'down' }
];

export enum CrossOutDirectionEnum {
  up = 'up',
  center = 'center',
  down = 'down'
}

export const TEXT_FILTER = [
  { text: 'as is', value: 'none' },
  { text: 'Tt Tt', value: 'title' },
  { text: 'Tt', value: 'capitalize' },
  { text: 'tt', value: 'lower' },
  { text: 'TT', value: 'upper' }
];

export const SNAP_TYPE = [
  { icon: 'assets/gravity-component/top-left.svg', value: 'top-left' },
  { icon: 'assets/gravity-component/top.svg', value: 'top' },
  { icon: 'assets/gravity-component/top-right.svg', value: 'top-right' },
  { icon: 'assets/gravity-component/left.svg', value: 'left' },
  { icon: 'assets/gravity-component/center.svg', value: 'center' },
  { icon: 'assets/gravity-component/right.svg', value: 'right' },
  { icon: 'assets/gravity-component/bottom-left.svg', value: 'bottom-left' },
  { icon: 'assets/gravity-component/bottom.svg', value: 'bottom' },
  { icon: 'assets/gravity-component/bottom-right.svg', value: 'bottom-right' }
];

export const ADDITIONAL_PROPERTIES = [
  'hasControls',
  'editable',
  'label',
  'gravity',
  'productType',
  'lockScalingY',
  'editable',
  'textLines',
  'textWidth',
  'textFilter',
  'additionalText',
  'asteriskAfterPrice',
  'textBeforeAfterPrice',
  'numberFormat',
  'clipPath',
  'name',
  'rx',
  'ry',
  'type',
  'boundWidth',
  'boundHeight',
  'boundLeft',
  'boundTop',
  'isUnderlay',
  'underlayColor',
  'underlayHorizontalPadding',
  'underlayVerticalPadding',
  'underlayOpacity',
  'isCrossedOut',
  'isCrossedUnderlay',
  'crossOutWidth',
  'crossOutColor',
  'crossOutDirection',
  'appendRandom',
  'randomRangeFrom',
  'randomRangeTo',
  'isTrim',
  'isTrimAndFit',
  'isBackgroundRemoved',
  'isSticker',
  'stickerBorderColor',
  'srcTransform',
  'strokeUniform',
  'cropWidth',
  'cropHeight',
  'cropTop',
  'cropLeft',
  'currency',
  'objectVersion'
];

export const EDITOR_DIMENSIONS: InjectionToken<EditorDimenstions> = new InjectionToken(
  'Editor dimensions'
);

export const ONE_TO_ONE_RATIO = {
  width: 600,
  height: 600
};

export const FOUR_TO_FIVE_RATIO = {
  width: 600,
  height: 750
};

export const NINE_TO_SIXTEEN_RATIO = {
  width: 1080,
  height: 1920
};

export const EDITOR_RATIOS: EditorRatio[] = [
  {
    label: '1x1',
    dimensions: ONE_TO_ONE_RATIO
  },
  {
    label: '4x5',
    dimensions: FOUR_TO_FIVE_RATIO
  },
  {
    label: '9x16',
    dimensions: NINE_TO_SIXTEEN_RATIO
  }
];

export const SCALED_EDITOR_DIMENSIONS: InjectionToken<EditorDimenstions> = new InjectionToken(
  'Scaled editor dimensions'
);

export const EDITOR_SCALE_RATE = 1;

export const IMAGE_FARM_ORIGINAL_URL_REGEX = new RegExp(
  `^https?:\/\/(image|img(-.+?)?)\.aitarget\.(tech|com)\.+[\/|\?]http`
);

export const DEFAULT_TITLE = () => `New overlay ${new Date().toLocaleString('ru-RU')}`;
export const DEFAULT_TEXT = 'lorem ipsum';

export const DEFAULT_TEXT_COLOR = '#000000';
export const DEFAULT_TEXT_FONT_FAMILY = 'Helvetica';
export const DEFAULT_SHAPE_COLOR = '#7d35f7';
export const DEFAULT_BORDER_COLOR = '#331960ff';
export const DEFAULT_TEXT_FILTER = 'none';
export const DEFAULT_STICKER_BORDER_COLOR = '#ffffff';

export const GRID_OPTIONS = {
  size: 20,
  color: '#cccccc33',
  opacity: 1
};

export const DEFAULT_LINE_OPTIONS = {
  strokeStyle: '#00FFFF',
  lineWidth: 2,
  globalAlpha: 0.9,
  lineDash: [6, 4]
};

export const DEFAULT_IMAGE_BOUND_OPTIONS = {
  strokeStyle: '#0000FF',
  lineWidth: 2,
  globalAlpha: 0.9,
  lineDash: [4, 6]
};

export const DEFAULT_EDITOR_SETTINGS = {
  hoverCursor: 'pointer',
  selection: true,
  backgroundColor: '#FFFFFF',
  selectionKey: ['ctrlKey', 'shiftKey'],
  fireRightClick: true,
  preserveObjectStacking: true,
  selectionBorderColor: '#6699FFDD',
  selectionColor: '#6699FF33',
  selectionLineWidth: 2,
  borderScaleFactor: 2,
  borderColor: '#6699FFDD',
  cornerColor: '#6699FFCC',
  cornerSize: 15,
  borderOpacityWhenMoving: 0.5,
  snapAngle: 15,
  transparentCorners: true,
  skipOffscreen: false,
  controlsAboveOverlay: true
};

export const IMAGE_FARM_URL = `https://image.aitarget.tech/image/`;

export const ADDITIONAL_PRODUCT_IMAGE_TEXT_TYPE: { name: string; value: TextTypes } = {
  name: 'Additional image',
  value: 'additional_image'
};

export const TEXT_TYPES: { name: string; value: TextTypes }[] = [
  { name: 'Name', value: 'name' },
  { name: 'Price', value: 'price' },
  { name: 'Product type', value: 'product_type' },
  { name: 'Sale price', value: 'sale_price' },
  { name: 'Actual price', value: 'actual_price' },
  { name: 'Sale value', value: 'sale_value' },
  { name: 'Sale percent', value: 'sale_percent' },
  { name: 'Brand', value: 'brand' },
  { name: 'Custom Label 0', value: 'custom_label_0' },
  { name: 'Custom Label 1', value: 'custom_label_1' },
  { name: 'Custom Label 2', value: 'custom_label_2' },
  { name: 'Custom Label 3', value: 'custom_label_3' },
  { name: 'Custom Label 4', value: 'custom_label_4' },
  { name: 'Custom Number 0', value: 'custom_number_0' },
  { name: 'Custom Number 1', value: 'custom_number_1' },
  { name: 'Custom Number 2', value: 'custom_number_2' },
  { name: 'Custom Number 3', value: 'custom_number_3' },
  { name: 'Custom Number 4', value: 'custom_number_4' },
  ADDITIONAL_PRODUCT_IMAGE_TEXT_TYPE
];

export const SIMPLE_TEXT: { name: string; value: string } = {
  name: 'Simple text',
  value: 'simple_text'
};

export const SIMPLE_IMAGE: { name: string; value: string } = {
  name: 'Simple image',
  value: 'simple_image'
};

// TODO: add custom fields?
export const PRODUCT_FIELDS = [
  'id',
  'retailer_id',
  'destination_id',
  'vehicle_id',
  'hotel_id',
  'image_url',
  'name',
  'title',
  'price',
  'product_type',
  'address',
  'sale_price',
  'actual_price',
  'sale_value',
  'sale_percent',
  'brand',
  'custom_label_0',
  'custom_label_1',
  'custom_label_2',
  'custom_label_3',
  'custom_label_4',
  'custom_number_0',
  'custom_number_1',
  'custom_number_2',
  'custom_number_3',
  'custom_number_4',
  'additional_image_urls',
  'currency',
  'images'
];

export const TEXT_FORMATS = [
  'title',
  'name',
  'brand',
  'product_type',
  'custom_label_0',
  'custom_label_1',
  'custom_label_2',
  'custom_label_3',
  'custom_label_4',
  'custom_number_0',
  'custom_number_1',
  'custom_number_2',
  'custom_number_3',
  'custom_number_4',
  'number',
  'string'
];

export const DEFAULT_TEXT_TYPE = { name: '-', value: 'default' };
export const PRODUCT_IMAGE_TEXT_TYPE = { name: 'Product image', value: 'product_image' };

export const FIELD_LIST_OBJECT_TYPE = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  TextExt: [
    'label',
    'text',
    'fontFamily',
    'fontSize',
    'fill',
    'lineHeight',
    'textAlign',
    'isUnderlay',
    'appendRandom',
    'left',
    'top',
    'angle',
    'stroke'
  ],
  // eslint-disable-next-line @typescript-eslint/naming-convention
  TextBoxExt: [
    'label',
    'fontFamily',
    'fontSize',
    'fill',
    'lineHeight',
    'textAlign',
    'gravity',
    'textFilter',
    'additionalText',
    'asteriskAfterPrice',
    'textBeforeAfterPrice',
    'numberFormat',
    'isUnderlay',
    'isCrossedOut',
    'left',
    'top',
    'currency',
    'textWidth',
    'angle',
    'stroke'
  ],
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ImageExt: ['borderRadius', 'opacity', 'gravity', 'left', 'top', 'width', 'height', 'angle'],
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ImageExtLogo: ['label', 'borderRadius', 'opacity', 'left', 'top', 'width', 'height'],
  // eslint-disable-next-line @typescript-eslint/naming-convention
  LineExt: ['label', 'fill', 'borderRadius', 'left', 'top', 'width', 'height', 'stroke', 'angle'],
  rect: ['label', 'fill', 'borderRadius', 'left', 'top', 'width', 'height', 'stroke', 'angle'],
  temperature: [
    'label',
    'fontFamily',
    'fontSize',
    'fill',
    'lineHeight',
    'textAlign',
    'isUnderlay',
    'left',
    'top',
    'angle',
    'city',
    'temperatureUnits',
    'temperatureFormat',
    'stroke'
  ],
  weather: [
    'opacity',
    'gravity',
    'left',
    'top',
    'width',
    'height',
    'angle',
    'city',
    'weatherIconTheme',
    'stroke'
  ],
  polygon: [
    'label',
    'fill',
    'borderRadius',
    'left',
    'top',
    'width',
    'height',
    'angle',
    'polygonSides'
  ],
  star: [
    'label',
    'fill',
    'borderRadius',
    'left',
    'top',
    'width',
    'height',
    'angle',
    'polygonSides',
    'innerRadius'
  ],
  circle: ['label', 'fill', 'left', 'top', 'width', 'height', 'stroke', 'angle'],
  triangle: ['label', 'fill', 'left', 'top', 'width', 'height', 'angle'],
  grid: ['showGrid', 'gridSize', 'gridColor'],
  background: ['canvasFill', 'backgroundAuto']
};

/* Currency view format */
export const DEFAULT_ADDITIONAL_TEXT = {
  name: 'None',
  value: 'none',
  filter: 'none',
  currencyCode: 'none'
};

export const TEMPLATE_ADDITIONAL_TEXT = [
  { name: '96{{currency}}', value: '{{currency}}', filter: 'after' },
  { name: '96{{currency}}*', value: '{{currency}}*', filter: 'after' },
  { name: '96 {{currency}}', value: ' {{currency}}', filter: 'after' },
  { name: '96 {{currency}}*', value: ' {{currency}}*', filter: 'after' },
  { name: '{{currency}}96', value: '{{currency}}', filter: 'before' },
  { name: '{{currency}} 96', value: '{{currency}} ', filter: 'before' }
];

export const ADDITIONAL_RAND_LIST = [
  { name: '96ZAR', value: 'ZAR', filter: 'after' },
  { name: '96ZAR*', value: 'ZAR*', filter: 'after' },
  { name: '96 ZAR', value: ' ZAR', filter: 'after' },
  { name: '96 ZAR*', value: ' ZAR*', filter: 'after' }
];

export const ADDITIONAL_RUB_LIST = [
  { name: '96 RUB', value: ' RUB', filter: 'after' },
  { name: '96 RUB*', value: ' RUB*', filter: 'after' },
  { name: '96 Р', value: ' Р', filter: 'after' },
  { name: '96 Р*', value: ' Р*', filter: 'after' },
  { name: '96 Р.', value: ' Р.', filter: 'after' },
  { name: '96 Р.*', value: ' Р.*', filter: 'after' },
  { name: '96 р', value: ' р', filter: 'after' },
  { name: '96 р*', value: ' р*', filter: 'after' },
  { name: '96 р.', value: ' р.', filter: 'after' },
  { name: '96 р.*', value: ' р.*', filter: 'after' },
  { name: '96 руб.', value: ' руб.', filter: 'after' },
  { name: '96 руб.*', value: ' руб.*', filter: 'after' },
  { name: '96 руб', value: ' руб', filter: 'after' },
  { name: '96 руб*', value: ' руб*', filter: 'after' },
  { name: '96 РУБ', value: ' РУБ', filter: 'after' },
  { name: '96 РУБ*', value: ' РУБ*', filter: 'after' },
  { name: '96 РУБ.', value: ' РУБ.', filter: 'after' },
  { name: '96 РУБ.*', value: ' РУБ.*', filter: 'after' },
  { name: '96RUB', value: 'RUB', filter: 'after' },
  { name: '96RUB*', value: 'RUB*', filter: 'after' },
  { name: '96Р', value: 'Р', filter: 'after' },
  { name: '96Р*', value: 'Р*', filter: 'after' },
  { name: '96Р.', value: 'Р.', filter: 'after' },
  { name: '96Р.*', value: 'Р.*', filter: 'after' },
  { name: '96р', value: 'р', filter: 'after' },
  { name: '96р*', value: 'р*', filter: 'after' },
  { name: '96р.', value: 'р.', filter: 'after' },
  { name: '96р.*', value: 'р.*', filter: 'after' },
  { name: '96руб.', value: 'руб.', filter: 'after' },
  { name: '96руб.*', value: 'руб.*', filter: 'after' },
  { name: '96руб', value: 'руб', filter: 'after' },
  { name: '96руб*', value: 'руб*', filter: 'after' },
  { name: '96РУБ', value: 'РУБ', filter: 'after' },
  { name: '96РУБ*', value: 'РУБ*', filter: 'after' },
  { name: '96РУБ.', value: 'РУБ.', filter: 'after' },
  { name: '96РУБ.*', value: 'РУБ.*', filter: 'after' },
  { name: '96РУБ', value: 'РУБ', filter: 'after' },
  { name: '96РУБ*', value: 'РУБ*', filter: 'after' },
  { name: '96РУБ.', value: 'РУБ.', filter: 'after' },
  { name: '96РУБ.*', value: 'РУБ.*', filter: 'after' }
];

export const ADDITIONAL_BYN_LIST = [
  { name: '96BYN', value: 'BYN', filter: 'after' },
  { name: '96BYN*', value: 'BYN*', filter: 'after' },
  { name: '96 BYN', value: ' BYN', filter: 'after' },
  { name: '96 BYN*', value: ' BYN*', filter: 'after' },
  { name: 'BYN96', value: 'BYN', filter: 'before' },
  { name: 'BYN 96', value: 'BYN ', filter: 'before' }
];

export const ADDITIONAL_KZT_LIST = [
  { name: '96 тг', value: ' тг', filter: 'after' },
  { name: '96 тг*', value: ' тг*', filter: 'after' },
  { name: '96KZT', value: 'KZT', filter: 'after' },
  { name: '96KZT*', value: 'KZT*', filter: 'after' },
  { name: '96 KZT', value: ' KZT', filter: 'after' },
  { name: '96 KZT*', value: ' KZT*', filter: 'after' },
  { name: 'KZT96', value: 'KZT', filter: 'before' },
  { name: 'KZT 96', value: 'KZT ', filter: 'before' }
];

export const ADDITIONAL_CAD_LIST = [{ name: '96 $ CA', value: ' $ CA', filter: 'after' }];

export const ADDITIONAL_BGN_LIST = [{ name: '96 лв', value: ' лв', filter: 'after' }];

export const ADDITIONAL_CLP_LIST = [{ name: '$96', value: '$', filter: 'before' }];

export const ADDITIONAL_UAH_LIST = [
  { name: '96 грн', value: ' грн', filter: 'after' },
  { name: '96 грн*', value: ' грн*', filter: 'after' }
];

export const ADDITIONAL_INR_LIST = [{ name: 'Rs. 96', value: 'Rs. ', filter: 'before' }];

export const ADDITIONAL_MXN_LIST = [{ name: '$96', value: '$', filter: 'before' }];

export const ADDITIONAL_SEK_LIST = [
  { name: '96SEK', value: 'SEK', filter: 'after' },
  { name: '96SEK*', value: 'SEK*', filter: 'after' },
  { name: '96 SEK', value: ' SEK', filter: 'after' },
  { name: '96 SEK*', value: ' SEK*', filter: 'after' },
  { name: '96kr', value: 'kr', filter: 'after' },
  { name: '96kr*', value: 'kr*', filter: 'after' },
  { name: '96 kr', value: ' kr', filter: 'after' },
  { name: '96 kr*', value: ' kr*', filter: 'after' }
];

export const ADDITIONAL_NOK_LIST = [{ name: 'kr 96', value: 'kr ', filter: 'before' }];

export const ADDITIONAL_RON_LIST = [{ name: '96 lei', value: ' lei', filter: 'after' }];

export const ADDITIONAL_TRY_LIST = [{ name: '₺96', value: '₺', filter: 'before' }];

export const ADDITIONAL_DKK_LIST = [{ name: '96 kr.', value: ' kr.', filter: 'after' }];

export const ADDITIONAL_TEXT_LIST = [
  { name: 'None', value: 'none', filter: 'none' },
  { name: '96 RUB', value: ' RUB', filter: 'after' },
  { name: '96 RUB*', value: ' RUB*', filter: 'after' },
  { name: '96 ₽', value: ' ₽', filter: 'after' },
  { name: '96 ₽*', value: ' ₽*', filter: 'after' },
  { name: '96 Р', value: ' Р', filter: 'after' },
  { name: '96 Р*', value: ' Р*', filter: 'after' },
  { name: '96 Р.', value: ' Р.', filter: 'after' },
  { name: '96 Р.*', value: ' Р.*', filter: 'after' },
  { name: '96 р', value: ' р', filter: 'after' },
  { name: '96 р*', value: ' р*', filter: 'after' },
  { name: '96 р.', value: ' р.', filter: 'after' },
  { name: '96 р.*', value: ' р.*', filter: 'after' },
  { name: '96 руб.', value: ' руб.', filter: 'after' },
  { name: '96 руб.*', value: ' руб.*', filter: 'after' },
  { name: '96 руб', value: ' руб', filter: 'after' },
  { name: '96 руб*', value: ' руб*', filter: 'after' },
  { name: '96 РУБ', value: ' РУБ', filter: 'after' },
  { name: '96 РУБ*', value: ' РУБ*', filter: 'after' },
  { name: '96 РУБ.', value: ' РУБ.', filter: 'after' },
  { name: '96 РУБ.*', value: ' РУБ.*', filter: 'after' },
  { name: '96RUB', value: 'RUB', filter: 'after' },
  { name: '96RUB*', value: 'RUB*', filter: 'after' },
  { name: '96₽', value: '₽', filter: 'after' },
  { name: '96₽*', value: '₽*', filter: 'after' },
  { name: '96Р', value: 'Р', filter: 'after' },
  { name: '96Р*', value: 'Р*', filter: 'after' },
  { name: '96Р.', value: 'Р.', filter: 'after' },
  { name: '96Р.*', value: 'Р.*', filter: 'after' },
  { name: '96р', value: 'р', filter: 'after' },
  { name: '96р*', value: 'р*', filter: 'after' },
  { name: '96р.', value: 'р.', filter: 'after' },
  { name: '96р.*', value: 'р.*', filter: 'after' },
  { name: '96руб.', value: 'руб.', filter: 'after' },
  { name: '96руб.*', value: 'руб.*', filter: 'after' },
  { name: '96руб', value: 'руб', filter: 'after' },
  { name: '96руб*', value: 'руб*', filter: 'after' },
  { name: '96РУБ', value: 'РУБ', filter: 'after' },
  { name: '96РУБ*', value: 'РУБ*', filter: 'after' },
  { name: '96РУБ.', value: 'РУБ.', filter: 'after' },
  { name: '96РУБ.*', value: 'РУБ.*', filter: 'after' },
  { name: '96РУБ', value: 'РУБ', filter: 'after' },
  { name: '96РУБ*', value: 'РУБ*', filter: 'after' },
  { name: '96РУБ.', value: 'РУБ.', filter: 'after' },
  { name: '96РУБ.*', value: 'РУБ.*', filter: 'after' },
  { name: '96ZAR', value: 'ZAR', filter: 'after' },
  { name: '96ZAR*', value: 'ZAR*', filter: 'after' },
  { name: '96 ZAR', value: ' ZAR', filter: 'after' },
  { name: '96 ZAR*', value: ' ZAR*', filter: 'after' },
  { name: '96SEK', value: 'SEK', filter: 'after' },
  { name: '96SEK*', value: 'SEK*', filter: 'after' },
  { name: '96 SEK', value: ' SEK', filter: 'after' },
  { name: '96 SEK*', value: ' SEK*', filter: 'after' },
  { name: '96kr', value: 'kr', filter: 'after' },
  { name: '96kr*', value: 'kr*', filter: 'after' },
  { name: '96 kr', value: ' kr', filter: 'after' },
  { name: '96 kr*', value: ' kr*', filter: 'after' },
  { name: '96 тг', value: ' тг', filter: 'after' },
  { name: '96 тг*', value: ' тг*', filter: 'after' },
  { name: '96 грн', value: ' грн', filter: 'after' },
  { name: '96 грн*', value: ' грн*', filter: 'after' },
  { name: '$96', value: '$', filter: 'before' },
  { name: '$ 96*', value: '$ *', filter: 'before' },
  { name: '€96', value: '€', filter: 'before' },
  { name: '€ 96*', value: '€ *', filter: 'before' },
  { name: '£96', value: '£', filter: 'before' },
  { name: '£ 96*', value: '£ *', filter: 'before' }
];

export const ADDITIONAL_TEXT_PERCENT_LIST = [
  { name: 'None', value: 'none', filter: 'none' },
  { name: '-96', value: '-', filter: 'before' },
  { name: '- 96', value: '- ', filter: 'before' },
  { name: '-96%', value: '-;%', filter: 'both' },
  { name: '-96 %', value: '-; %', filter: 'both' },
  { name: '- 96%', value: '- ;%', filter: 'both' },
  { name: '- 96 %', value: '- ; %', filter: 'both' },
  { name: '96%', value: '%', filter: 'after' },
  { name: '96 %', value: ' %', filter: 'after' },
  { name: '%96', value: '%', filter: 'before' },
  { name: '% 96', value: '% ', filter: 'before' },
  { name: '96pct.', value: 'pct.', filter: 'after' },
  { name: '96 pct.', value: ' pct.', filter: 'after' },
  { name: '96pct', value: 'pct', filter: 'after' },
  { name: '96 pct', value: ' pct', filter: 'after' },
  { name: '96 percent', value: ' percent', filter: 'after' }
];

export const ADDITIONAL_TEXT_LIST_NEGATIVE = [
  { name: '-96 RUB', value: '-; RUB', filter: 'both' },
  { name: '-96 RUB*', value: '-; RUB*', filter: 'both' },
  { name: '-96 ₽', value: '-; ₽', filter: 'both' },
  { name: '-96 ₽*', value: '-; ₽*', filter: 'both' },
  { name: '-96 Р', value: '-; Р', filter: 'both' },
  { name: '-96 Р*', value: '-; Р*', filter: 'both' },
  { name: '-96 Р.', value: '-; Р.', filter: 'both' },
  { name: '-96 Р.*', value: '-; Р.*', filter: 'both' },
  { name: '-96 р', value: '-; р', filter: 'both' },
  { name: '-96 р*', value: '-; р*', filter: 'both' },
  { name: '-96 р.', value: '-; р.', filter: 'both' },
  { name: '-96 р.*', value: '-; р.*', filter: 'both' },
  { name: '-96 руб.', value: '-; руб.', filter: 'both' },
  { name: '-96 руб.*', value: '-; руб.*', filter: 'both' },
  { name: '-96 руб', value: '-; руб', filter: 'both' },
  { name: '-96 руб*', value: '-; руб*', filter: 'both' },
  { name: '-96 РУБ', value: '-; РУБ', filter: 'both' },
  { name: '-96 РУБ*', value: '-; РУБ*', filter: 'both' },
  { name: '-96 РУБ.', value: '-; РУБ.', filter: 'both' },
  { name: '-96 РУБ.*', value: '-; РУБ.*', filter: 'both' },
  { name: '-96RUB', value: '-;RUB', filter: 'both' },
  { name: '-96RUB*', value: '-;RUB*', filter: 'both' },
  { name: '-96₽', value: '-;₽', filter: 'both' },
  { name: '-96₽*', value: '-;₽*', filter: 'both' },
  { name: '-96Р', value: '-;Р', filter: 'both' },
  { name: '-96Р*', value: '-;Р*', filter: 'both' },
  { name: '-96Р.', value: '-;Р.', filter: 'both' },
  { name: '-96Р.*', value: '-;Р.*', filter: 'both' },
  { name: '-96р', value: '-;р', filter: 'both' },
  { name: '-96р*', value: '-;р*', filter: 'both' },
  { name: '-96р.', value: '-;р.', filter: 'both' },
  { name: '-96р.*', value: '-;р.*', filter: 'both' },
  { name: '-96руб.', value: '-;руб.', filter: 'both' },
  { name: '-96руб.*', value: '-;руб.*', filter: 'both' },
  { name: '-96руб', value: '-;руб', filter: 'both' },
  { name: '-96руб*', value: '-;руб*', filter: 'both' },
  { name: '-96РУБ', value: '-;РУБ', filter: 'both' },
  { name: '-96РУБ*', value: '-;РУБ*', filter: 'both' },
  { name: '-96РУБ.', value: '-;РУБ.', filter: 'both' },
  { name: '-96РУБ.*', value: '-;РУБ.*', filter: 'both' },
  { name: '-96РУБ', value: '-;РУБ', filter: 'both' },
  { name: '-96РУБ*', value: '-;РУБ*', filter: 'both' },
  { name: '-96РУБ.', value: '-;РУБ.', filter: 'both' },
  { name: '-96РУБ.*', value: '-;РУБ.*', filter: 'both' },
  { name: '-96ZAR', value: '-;ZAR', filter: 'both' },
  { name: '-96ZAR*', value: '-;ZAR*', filter: 'both' },
  { name: '-96 ZAR', value: '-; ZAR', filter: 'both' },
  { name: '-96 ZAR*', value: '-; ZAR*', filter: 'both' },
  { name: '-96SEK', value: '-;SEK', filter: 'both' },
  { name: '-96SEK*', value: '-;SEK*', filter: 'both' },
  { name: '-96 SEK', value: '-; SEK', filter: 'both' },
  { name: '-96 SEK*', value: '-; SEK*', filter: 'both' },
  { name: '-96kr', value: '-;kr', filter: 'both' },
  { name: '-96kr*', value: '-;kr*', filter: 'both' },
  { name: '-96 kr', value: '-; kr', filter: 'both' },
  { name: '-96 kr*', value: '-; kr*', filter: 'both' },
  { name: '-96 тг', value: '-; тг', filter: 'both' },
  { name: '-96 тг*', value: '-; тг*', filter: 'both' },
  { name: '-96 грн', value: '-; грн', filter: 'both' },
  { name: '-96 грн*', value: '-; грн*', filter: 'both' },
  { name: '-$96', value: '-;$', filter: 'both' },
  { name: '-$ 96', value: '-$ ;', filter: 'both' },
  { name: '-€96', value: '-€;', filter: 'both' },
  { name: '-€ 96', value: '-€ ;', filter: 'both' },
  { name: '-96€', value: '-;€', filter: 'both' },
  { name: '-96€*', value: '-;€*', filter: 'both' },
  { name: '-96 €', value: '-; €', filter: 'both' },
  { name: '-96 €*', value: '-; €*', filter: 'both' },
  { name: '-£96', value: '-£;', filter: 'both' },
  { name: '-£ 96', value: '-£ ;', filter: 'both' }
];
/* Currency view format */

export const CURRENCY_LIST = [
  { name: 'Euro', value: 'EUR', currency: '€' },
  { name: 'US Dollar', value: 'USD', currency: '$' },
  { name: 'Afghani', value: 'AFN', currency: 'Af' },
  { name: 'Algerian Dinar', value: 'DZD', currency: 'DA' },
  { name: 'Argentine Peso', value: 'ARS', currency: 'AR$' },
  { name: 'Armenian Dram', value: 'AMD', currency: 'AMD' },
  { name: 'Australian Dollar', value: 'AUD', currency: 'AU$' },
  { name: 'Azerbaijan Manat', value: 'AZN', currency: '₼' },
  { name: 'Bahraini Dinar', value: 'BHD', currency: 'BD' },
  { name: 'Baht', value: 'THB', currency: '฿' },
  { name: 'Balboa', value: 'PAB', currency: 'B/.' },
  { name: 'Belarusian Ruble', value: 'BYN', currency: 'Br', additionalText: ADDITIONAL_BYN_LIST },
  { name: 'Belize Dollar', value: 'BZD', currency: 'BZ$' },
  { name: 'Boliviano', value: 'BOB', currency: 'Bs' },
  { name: 'Brazilian Real', value: 'BRL', currency: 'R$' },
  { name: 'Brunei Dollar', value: 'BND', currency: 'BN$' },
  { name: 'Bulgarian Lev', value: 'BGN', currency: 'BGN', additionalText: ADDITIONAL_BGN_LIST },
  { name: 'Burundi Franc', value: 'BIF', currency: 'FBu' },
  { name: 'CFA Franc BCEAO', value: 'XOF', currency: 'CFA' },
  { name: 'CFA Franc BEAC', value: 'XAF', currency: 'FCFA' },
  { name: 'Cabo Verde Escudo', value: 'CVE', currency: 'CV$' },
  { name: 'Canadian Dollar', value: 'CAD', currency: 'CA$', additionalText: ADDITIONAL_CAD_LIST },
  { name: 'Chilean Peso', value: 'CLP', currency: 'CL$', additionalText: ADDITIONAL_CLP_LIST },
  { name: 'Colombian Peso', value: 'COP', currency: 'CO$' },
  { name: 'Comorian Franc', value: 'KMF', currency: 'CF' },
  { name: 'Congolese Franc', value: 'CDF', currency: 'CDF' },
  { name: 'Convertible Mark', value: 'BAM', currency: 'KM' },
  { name: 'Cordoba Oro', value: 'NIO', currency: 'C$' },
  { name: 'Costa Rican Colon', value: 'CRC', currency: '₡' },
  { name: 'Czech Koruna', value: 'CZK', currency: 'Kč' },
  { name: 'Danish Krone', value: 'DKK', currency: 'Dkr', additionalText: ADDITIONAL_DKK_LIST },
  { name: 'Denar', value: 'MKD', currency: 'MKD' },
  { name: 'Djibouti Franc', value: 'DJF', currency: 'Fdj' },
  { name: 'Dominican Peso', value: 'DOP', currency: 'RD$' },
  { name: 'Dong', value: 'VND', currency: '₫' },
  { name: 'Egyptian Pound', value: 'EGP', currency: 'EGP' },
  { name: 'Ethiopian Birr', value: 'ETB', currency: 'Br' },
  { name: 'Forint', value: 'HUF', currency: 'Ft' },
  { name: 'Ghana Cedi', value: 'GHS', currency: 'GH₵' },
  { name: 'Guarani', value: 'PYG', currency: '₲' },
  { name: 'Guinean Franc', value: 'GNF', currency: 'FG' },
  { name: 'Hong Kong Dollar', value: 'HKD', currency: 'HK$' },
  {
    name: 'Hryvnia',
    value: 'UAH',
    currency: '₴',
    additionalText: ADDITIONAL_UAH_LIST
  },
  { name: 'Iceland Krona', value: 'ISK', currency: 'Ikr' },
  { name: 'Indian Rupee', value: 'INR', currency: '₹', additionalText: ADDITIONAL_INR_LIST },
  { name: 'Iranian Rial', value: 'IRR', currency: 'IRR' },
  { name: 'Iraqi Dinar', value: 'IQD', currency: 'IQD' },
  { name: 'Jamaican Dollar', value: 'JMD', currency: 'J$' },
  { name: 'Jordanian Dinar', value: 'JOD', currency: 'JD' },
  { name: 'Kenyan Shilling', value: 'KES', currency: 'Ksh' },
  { name: 'Kuna', value: 'HRK', currency: 'kn' },
  { name: 'Kuwaiti Dinar', value: 'KWD', currency: 'KD' },
  { name: 'Kyat', value: 'MMK', currency: 'MMK' },
  { name: 'Lari', value: 'GEL', currency: 'GEL' },
  { name: 'Lebanese Pound', value: 'LBP', currency: 'LB£' },
  { name: 'Lek', value: 'ALL', currency: 'ALL' },
  { name: 'Lempira', value: 'HNL', currency: 'HNL' },
  { name: 'Libyan Dinar', value: 'LYD', currency: 'LD' },
  { name: 'Malagasy Ariary', value: 'MGA', currency: 'MGA' },
  { name: 'Malaysian Ringgit', value: 'MYR', currency: 'RM' },
  { name: 'Mauritius Rupee', value: 'MUR', currency: 'MURs' },
  { name: 'Mexican Peso', value: 'MXN', currency: 'MX$', additionalText: ADDITIONAL_MXN_LIST },
  { name: 'Moldovan Leu', value: 'MDL', currency: 'MDL' },
  { name: 'Moroccan Dirham', value: 'MAD', currency: 'MAD' },
  { name: 'Mozambique Metical', value: 'MZN', currency: 'MTn' },
  { name: 'Naira', value: 'NGN', currency: '₦' },
  { name: 'Nakfa', value: 'ERN', currency: 'Nfk' },
  { name: 'Namibia Dollar', value: 'NAD', currency: 'N$' },
  { name: 'Nepalese Rupee', value: 'NPR', currency: 'NPRs' },
  { name: 'New Israeli Sheqel', value: 'ILS', currency: '₪' },
  { name: 'New Taiwan Dollar', value: 'TWD', currency: 'NT$' },
  { name: 'New Zealand Dollar', value: 'NZD', currency: 'NZ$' },
  { name: 'Norwegian Krone', value: 'NOK', currency: 'Nkr', additionalText: ADDITIONAL_NOK_LIST },
  { name: 'Pakistan Rupee', value: 'PKR', currency: 'PKRs' },
  { name: 'Pataca', value: 'MOP', currency: 'MOP$' },
  { name: 'Pa’anga', value: 'TOP', currency: 'T$' },
  { name: 'Peso Uruguayo', value: 'UYU', currency: '$U' },
  { name: 'Philippine Peso', value: 'PHP', currency: '₱' },
  { name: 'Pound Sterling', value: 'GBP', currency: '£' },
  { name: 'Pula', value: 'BWP', currency: 'BWP' },
  { name: 'Qatari Rial', value: 'QAR', currency: 'QR' },
  { name: 'Quetzal', value: 'GTQ', currency: 'GTQ' },
  {
    name: 'Rand',
    value: 'ZAR',
    currency: 'R',
    additionalText: ADDITIONAL_RAND_LIST
  },
  { name: 'Rial Omani', value: 'OMR', currency: 'OMR' },
  { name: 'Riel', value: 'KHR', currency: 'KHR' },
  { name: 'Romanian Leu', value: 'RON', currency: 'RON', additionalText: ADDITIONAL_RON_LIST },
  { name: 'Rupiah', value: 'IDR', currency: 'Rp' },
  {
    name: 'Russian Ruble',
    value: 'RUB',
    currency: '₽',
    additionalText: ADDITIONAL_RUB_LIST
  },
  { name: 'Rwanda Franc', value: 'RWF', currency: 'RWF' },
  { name: 'Saudi Riyal', value: 'SAR', currency: 'SR' },
  { name: 'Serbian Dinar', value: 'RSD', currency: 'din.' },
  { name: 'Singapore Dollar', value: 'SGD', currency: 'S$' },
  { name: 'Sol', value: 'PEN', currency: 'S/.' },
  { name: 'Somali Shilling', value: 'SOS', currency: 'Ssh' },
  { name: 'Sri Lanka Rupee', value: 'LKR', currency: 'SLRs' },
  { name: 'Sudanese Pound', value: 'SDG', currency: 'SDG' },
  {
    name: 'Swedish Krona',
    value: 'SEK',
    currency: 'Skr',
    additionalText: ADDITIONAL_SEK_LIST
  },
  { name: 'Swiss Franc', value: 'CHF', currency: 'CHF' },
  { name: 'Syrian Pound', value: 'SYP', currency: 'SY£' },
  { name: 'Taka', value: 'BDT', currency: 'Tk' },
  { name: 'Tanzanian Shilling', value: 'TZS', currency: 'TSh' },
  {
    name: 'Tenge',
    value: 'KZT',
    currency: '₸',
    additionalText: ADDITIONAL_KZT_LIST
  },
  { name: 'Trinidad and Tobago Dollar', value: 'TTD', currency: 'TT$' },
  { name: 'Tunisian Dinar', value: 'TND', currency: 'DT' },
  { name: 'Turkish Lira', value: 'TRY', currency: 'TL', additionalText: ADDITIONAL_TRY_LIST },
  { name: 'UAE Dirham', value: 'AED', currency: 'AED' },
  { name: 'Uganda Shilling', value: 'UGX', currency: 'USh' },
  { name: 'Uzbekistan Sum', value: 'UZS', currency: 'UZS' },
  { name: 'Won', value: 'KRW', currency: '₩' },
  { name: 'Yemeni Rial', value: 'YER', currency: 'YR' },
  { name: 'Yen', value: 'JPY', currency: '¥' },
  { name: 'Yuan Renminbi', value: 'CNY', currency: 'CN¥' },
  { name: 'Zimbabwe Dollar', value: 'ZWL', currency: 'ZWL$' },
  { name: 'Zloty', value: 'PLN', currency: 'zł' },
  { name: 'Luxembourg Franc', value: 'LUF', currency: 'F' }
];

export const SYMBOL_TO_SUFFIX = {
  '.': '\u00B7',
  ',': '\u2E34'
};

export const UPPERCASE_SYMBOL_TO_SUFFIX = {
  '0': '\u2070',
  '1': '\u00B9',
  '2': '\u00B2',
  '3': '\u00B3',
  '4': '\u2074',
  '5': '\u2075',
  '6': '\u2076',
  '7': '\u2077',
  '8': '\u2078',
  '9': '\u2079'
};

export const LOWERCASE_SYMBOL_TO_SUFFIX = {
  '0': '\u2080',
  '1': '\u2081',
  '2': '\u2082',
  '3': '\u2083',
  '4': '\u2084',
  '5': '\u2085',
  '6': '\u2086',
  '7': '\u2087',
  '8': '\u2088',
  '9': '\u2089'
};

export const NUMBER_FORMAT_EXAMPLE_LIST = [
  {
    name: 'None',
    value: '0',
    options: { decimal: 0, integer: 0, intDelimiter: '', decDelimiter: '' }
  },
  {
    name: '1234567',
    value: '1',
    options: { decimal: 0, integer: 0, intDelimiter: '', decDelimiter: '' }
  },
  {
    name: '1 234 567',
    value: '2',
    options: { decimal: 0, integer: 3, intDelimiter: ' ', decDelimiter: '' }
  },
  {
    name: '1,234,567',
    value: '3',
    options: { decimal: 0, integer: 3, intDelimiter: ',', decDelimiter: '' }
  },
  {
    name: '1 234 567.00',
    value: '4',
    options: { decimal: 2, integer: 3, intDelimiter: ' ', decDelimiter: '.' }
  },
  {
    name: '1,234,567.00',
    value: '5',
    options: { decimal: 2, integer: 3, intDelimiter: ',', decDelimiter: '.' }
  },
  {
    name: '1,234,567,00',
    value: '6',
    options: { decimal: 2, integer: 3, intDelimiter: ',', decDelimiter: ',' }
  },
  {
    name: '1 234 567,00',
    value: '7',
    options: { decimal: 2, integer: 3, intDelimiter: ' ', decDelimiter: ',' }
  },
  {
    name: '1 234 567·⁰⁰',
    value: '8',
    options: {
      decimal: 2,
      integer: 3,
      intDelimiter: ' ',
      decDelimiter: SYMBOL_TO_SUFFIX['.']
    }
  },
  {
    name: '1 234 567˒⁰⁰',
    value: '9',
    options: {
      decimal: 2,
      integer: 3,
      intDelimiter: ' ',
      decDelimiter: SYMBOL_TO_SUFFIX[',']
    }
  },
  {
    name: '1,234,567·⁰⁰',
    value: '10',
    options: {
      decimal: 2,
      integer: 3,
      intDelimiter: ',',
      decDelimiter: SYMBOL_TO_SUFFIX['.']
    }
  },
  {
    name: '1,234,567˒⁰⁰',
    value: '11',
    options: {
      decimal: 2,
      integer: 3,
      intDelimiter: ',',
      decDelimiter: SYMBOL_TO_SUFFIX[',']
    }
  },

  {
    name: '1 234 567.₀₀',
    value: '12',
    options: {
      decimal: 2,
      integer: 3,
      intDelimiter: ' ',
      decDelimiter: '.'
    }
  },
  {
    name: '1 234 567,₀₀',
    value: '13',
    options: {
      decimal: 2,
      integer: 3,
      intDelimiter: ' ',
      decDelimiter: ','
    }
  },
  {
    name: '1,234,567.₀₀',
    value: '14',
    options: {
      decimal: 2,
      integer: 3,
      intDelimiter: ',',
      decDelimiter: '.'
    }
  },
  {
    name: '1,234,567,₀₀',
    value: '15',
    options: {
      decimal: 2,
      integer: 3,
      intDelimiter: ',',
      decDelimiter: ','
    }
  }
];

export const TEMPERATURE_UNIT_LIST = [
  { id: 'metric', name: 'Celsius' },
  { id: 'standard', name: 'Kelvin' },
  { id: 'imperial', name: 'Fahrenheit' }
];

export const TEMPERATURE_FORMAT_LIST = [
  { id: 'metric', name: '24°C', value: '°C', filter: 'after' },
  { id: 'metric', name: '24 °C', value: ' °C', filter: 'after' },
  { id: 'imperial', name: '75°F', value: '°F', filter: 'after' },
  { id: 'imperial', name: '75 °F', value: ' °F', filter: 'after' },
  { id: 'standard', name: '297°K', value: '°K', filter: 'after' },
  { id: 'standard', name: '297 °K', value: ' °K', filter: 'after' }
];

export const OVERLAYS_FILE_SIZE = 200000000;

export const EMPTY_IMAGE = `data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==`;

export const LINE_LENGTH_MIN = 0;

export const LINE_LENGTH_MAX = 100;

export const LINE_LENGTH_STEP = 1;

export const MAX_BETA_PRODUCT_SET_COUNT = 50000;

export const LINE_HEIGHT_MULT = 1.13; // to equalize farm and editor line heights https://github.com/fabricjs/fabric.js/issues/2059

export const BACKEND_CORRECTION_ANGLE = 450;

export const SCROLL_DELAY = 300;

export const RANDOM_TEXT_ANCHOR_REGEX = /\{\d+}/;

export const FILE_EXTENSION = /\.([0-9a-z]{3,4})(?:[\?#]|$)/i;

export const FILE_NAME = /([^/\\&\?]+)\.\w{3,4}(?=[\?&#].*$|$)/i;

export const WEATHER_ICON_LIST = {
  light: {
    clear: 'c5be6ce2b76b488889ea1443c72e6c56',
    clouds: '7cd8a13d61524779bd8cd4b82e64a3a0',
    drizzle: 'ee0c7d4234074b83b1f92afe6dc52b50',
    dust: '5f791d8f0f034c67a71d2f4ca3dc4575',
    fog: '5038e5677275452b95a2dcb238e5c742',
    haze: '87b435e3f0d14eddade8a69db62e9503',
    mist: '24b6e89395af4407a6b0e460d9e76d76',
    rain: '98e944b47f1d4b3f80cbb2c8dfc9b596',
    sand: '9bdcf19c84d44b8d81ebcf8cd91b591b',
    smoke: 'b30b95e53ec44111a8e48f74ac147750',
    snow: 'df371df0a61a4ddbb1c4228fe63d95dd',
    squall: 'd3fed89f2ab54d0f84e0ae92d56d3bc9',
    thunderstorm: '7a3dcc522ca0477188b73f116ea100ca',
    tornado: '7e06ba852d7c4f92b91ac0a44b5e57d1'
  },
  dark: {
    clear: '8a2d675b384545bcaf40f3c38ff45781',
    clouds: '1040b6d9fabd414c84803ffab5f66e05',
    drizzle: 'b7566208c9ba46b58f917801e7535fa5',
    dust: '1153922f42bc48959b27181a4be5d304',
    fog: '24d007b4f07b4a76ad92931b8652fbdf',
    haze: 'b664caf677e04a3c85eba2e4db64c31f',
    mist: '5df168b90d14405ebe1cf3668c0c5f12',
    rain: '8e8d46cdb55c4352882ae5d4e1465a60',
    sand: 'aa68af8f5aa54be09f12c87f884917eb',
    smoke: '0cbc5914e9e6404091fcadfc95b22340',
    snow: 'c2efd68159e94c2598182b6e35091fbe',
    squall: '9de71c6153e941d0a6fd4a5cd478f4a1',
    thunderstorm: 'a8378a0403504ddd9feb27e5fdcd89f9',
    tornado: '5e9ff21f639b4d1f847d38e3b249b48d'
  }
};

export const NON_OPTIMIZED_OBJECT_TYPES = ['weather'];
